import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './FilterToggleButtons.css';

const FilterToggleButtons = ({ 
  options, 
  onSelectionChange,
  multiSelect = false,
  defaultSelected = [],
  containerStyle = {},
  buttonStyle = {}
}) => {
  const [selectedItems, setSelectedItems] = useState(defaultSelected);

  const handleToggle = (value) => {
    let newSelected;
    
    if (multiSelect) {
      // For multi-select, toggle the selection
      if (selectedItems.includes(value)) {
        newSelected = selectedItems.filter(item => item !== value);
      } else {
        newSelected = [...selectedItems, value];
      }
    } else {
      // For single select, replace the selection
      newSelected = selectedItems.includes(value) ? [] : [value];
    }
    
    setSelectedItems(newSelected);
    onSelectionChange(newSelected);
  };

  const handleTouchStart = (e) => {
    const container = e.currentTarget;
    container.touchStartX = e.touches[0].pageX;
    container.touchStartY = e.touches[0].pageY;
    container.scrollStart = container.scrollLeft;
    container.isScrolling = false;
  };

  const handleTouchMove = (e) => {
    const container = e.currentTarget;
    if (!container.touchStartX) return;
    
    const touchX = e.touches[0].pageX;
    const touchY = e.touches[0].pageY;
    const deltaX = Math.abs(touchX - container.touchStartX);
    const deltaY = Math.abs(touchY - container.touchStartY);
    
    // If horizontal movement is dominant, handle scrolling
    if (deltaX > deltaY && deltaX > 10) {
      container.isScrolling = true;
      e.preventDefault(); // Prevent page scroll
      e.stopPropagation();
      
      // Calculate new scroll position
      const moveX = container.touchStartX - touchX;
      container.scrollLeft = container.scrollStart + moveX;
    }
  };

  const handleTouchEnd = (e) => {
    const container = e.currentTarget;
    
    // If we were scrolling, prevent click events
    if (container.isScrolling) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    // Clean up
    setTimeout(() => {
      delete container.touchStartX;
      delete container.touchStartY;
      delete container.scrollStart;
      delete container.isScrolling;
    }, 50);
  };

  return (
    <div 
      className="filter-toggle-container"
      style={containerStyle}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {options.map((option) => (
        <button
          key={option.value}
          onClick={(e) => {
            // Prevent click if container was scrolling
            const container = e.currentTarget.parentElement;
            if (container.isScrolling) {
              e.preventDefault();
              return;
            }
            handleToggle(option.value);
          }}
          className={`filter-toggle-button ${selectedItems.includes(option.value) ? 'active' : ''}`}
          style={buttonStyle}
        >
          {option.icon && (
            <i 
              className={`icon ${option.icon}`}
            />
          )}
          {option.label}
        </button>
      ))}
    </div>
  );
};

FilterToggleButtons.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      icon: PropTypes.string
    })
  ).isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  multiSelect: PropTypes.bool,
  defaultSelected: PropTypes.arrayOf(PropTypes.string),
  containerStyle: PropTypes.object,
  buttonStyle: PropTypes.object
};

export default FilterToggleButtons; 